import { PrintTransaction } from "components";
import { useFormContext } from "react-hook-form";
import { FormReceivedType } from "../types";
import { APPROVAL, convertNumber, useEmployee, useLocation } from "utils";
import moment from "moment";

export function Print(): JSX.Element {

    const { watch } = useFormContext<FormReceivedType>();

    const location = useLocation();
    const employee = useEmployee()

    const isLoading: boolean = location.isLoading || employee.isLoadingEmployee
    const fromLocation = location.data.find(item => item.value === watch("location_from_id").toString())
    const destinationLocation = location.data.find(item => item.value === watch("location_to_id").toString())
    const employeeName = employee.dataEmployee.find(item => item.value === watch("transfer_employee_id").toString())
    const receivedBy= employee.dataEmployee.find(item => item.value === watch("employee_id").toString())
    const approvedBy = employee.dataEmployee.find(item => item.value === watch("approved_by")?.toString())
    const receivedItem = watch("received_detail")
    const totalReceived = receivedItem.reduce((acc, item) => acc + item.quantity_received, 0)

    

    return (
        <PrintTransaction loading={isLoading}>
            <section className="flex flex-col gap-5">
                <section>
                    <div className="w-fit bg-black text-white px-10 py-3">DATA ENTRY | RECEIVED INVENTORY</div>
                    <div className="border-y py-5 font-bold text-center">RECEIVED INVENTORY</div>
                </section>

                <section className="px-3 grid grid-cols-2 gap-3">
                    <InfoSection
                        list={[
                            {
                                label: "Source Location",
                                value: fromLocation?.label ?? "-"
                            },
                            {
                                label: "Recorded By",
                                value: employeeName?.label ?? "-"
                            },
                            {
                                label: "Transfer Date",
                                value: moment(watch("transfer_date")).format("DD-MM-YYYY") ?? "-"
                            },
                            {
                                label: "Transfer Memo",
                                value: watch("transfer_memo") ?? "-"
                            },
                            {
                                label: "Link Transfer ID#",
                                value: watch("transfer_link") ?? "-"
                            }
                        ]}
                    />

                    <InfoSection
                        list={[
                            {
                                label: "Code",
                                value: (watch("trx_code")) ?? ""
                            },
                            {
                                label: "Destination Location",
                                value: destinationLocation?.label ?? "-"
                            },
                            {
                                label: "Received By",
                                value: receivedBy?.label ?? "-"
                            },
                            {
                                label: "Received Date",
                                value: moment(watch("transaction_date")).format("DD-MM-YYYY") ?? ""
                            },
                            {
                                label: "Received Memo",
                                value: watch("memo") ?? "-"
                            },
                        ]}
                    />
                </section>

                <table className="table header-bordered">
                    <thead>
                        <tr className="bg-black text-white">
                            <th></th>
                            <th>Item Code</th>
                            <th>Description</th>
                            <th>Unit</th>
                            <th>Ship</th>
                            <th>Received</th>
                            <th>Reject</th>
                        </tr>
                    </thead>

                    <tbody>
                         {receivedItem.map((item, key) => (
                            <tr key={key}>
                                <td>{key + 1}</td>
                                <td>{item.product_barcode}</td>
                                <td>{item.product_name}</td>
                                <td>{item.unit_convention_name}</td>
                                <td className="text-right">{item.total_quantity_transfer}</td>
                                <td className="text-right">{item.quantity_received}</td>
                                <td className="text-right">{item.quantity_reject}</td>
                            </tr>
                         ))}
                    </tbody>
                </table>

                <section className="px-3 grid grid-cols-2 gap-3">
                    <InfoSection
                        list={[
                            {
                                label: "Approval Status",
                                value: APPROVAL[watch("approval_status")]
                            },
                            {
                                label: "Approved By",
                                value: approvedBy?.label ?? "-"
                            }
                        ]}
                    />

                    <InfoSection
                        class={{ value: "text-right font-bold"}}
                        list={[
                            {
                                label: "Total Received",
                                value: convertNumber(totalReceived).intoNormalAmount},
                        ]}
                    />
                </section>
            </section>
        </PrintTransaction>
    )
}

function InfoSection(params: {
    class?: { value?: string }
    list: {
        label: string
        value: string
    }[]
}): JSX.Element {
    return (
        <table className="h-fit table border-b">
            <tbody>
                {params.list.map((item, key) => (
                    <tr key={key}>
                        <td className="font-bold">{item.label}</td>
                        <td className={params?.class?.value}>{item.value}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    )
}